// extracted by mini-css-extract-plugin
export default {"details":"CategoryDetails-module__details__43guG","category":"CategoryDetails-module__category__8udMK","content":"CategoryDetails-module__content__2IAKk"};